export const ROUTE_APP_LANDING = "/home";

export const ROUTE_USER = "/user/:userId?";
export const ROUTE_USER_EDIT = "/user/:userId/edit";
export const ROUTE_USER_NOTIFICATIONS = "/user/:userId/notifications";

export const ROUTE_REFI_PROCEEDS_ANALYSIS_UNSUPERVISED = (dealId = ":dealId") => `/refiProceedsAnalysis/unsupervised/${dealId}`;
export const ROUTE_REFI_PROCEEDS_ANALYSIS_SUPERVISED = (dealId = ":dealId", loanSpreadId = ":loanSpreadId") => `/refiProceedsAnalysis/supervised/${dealId}/${loanSpreadId}`;

export const ROUTE_CONTACT = "/contact/:contactId?";
export const ROUTE_CONTACT_EDIT = "/contact/:contactId/edit";
export const ROUTE_CONTACT_NOTIFICATIONS = "/contact/:contactId/notifications";

export const ROUTE_PROFILE = "/profile/:userId";
export const ROUTE_PROFILE_NOTIFICATIONS = "/profile/notifications";

export const ROUTE_PORTFOLIO_CLOSED = "/portfolio/:loanId";
export const ROUTE_PORTFOLIO = "/portfolio";

export const ROUTE_PROPERTIES = "/properties";

export const ROUTE_LOGOUT = "/logout";
export const ROUTE_LOGIN = "/login";
export const ROUTE_ADMIN_LOGIN = "/adminlogin";

export const ROUTE_FORGOT_PASSWORD = "/forgotPassword";
export const ROUTE_CHANGE_PASSWORD = "/changePassword";

export const ROUTE_FUNDS = "/funds";
export const ROUTE_FUNDS_DETAIL = "/portfolio/funds/:fundId";
export const ROUTE_FUNDS_EDIT = "/funds/:fundId/edit";

export const ROUTE_DEALS = "/deals-retired";
export const ROUTE_DEALS_DETAILS = "/portfolio/funds/:fundId/deals/:dealId";
export const ROUTE_DEALS_EDIT = "/deals/:dealId/edit";
export const ROUTE_DEAL_NEW = "/newdeal";
export const ROUTE_CLOSED_DEAL_QUOTE_EDIT = "/deals/:dealId/quote/:quoteId";
export const ROUTE_DEAL_PROJECTIONS = "/projections/:dealId/:isPipeline";

export const ROUTE_CASHFLOW_EDIT = "/cashflow/:cashflowId/edit";

export const ROUTE_CALCULATORS = "/calculators";
export const ROUTE_CALCULATORS_AMORTIZATION = "/calculators/amortization";
export const ROUTE_CALCULATORS_FORWARD_CURVE = "/calculators/forwardCurve";
export const ROUTE_CALCULATORS_FORWARD_CURVE_NEW = "/calculators/forwardCurveNew";
export const ROUTE_CALCULATORS_YIELD_CURVES = "/calculators/yieldCurves";
export const ROUTE_CALCULATORS_TEST_HARNESS = "/calculators/testHarness";
export const ROUTE_CALCULATORS_BANK_SWAP = "/calculators/bankSwap";
export const ROUTE_CALCULATORS_BANK_SWAP_MODAL = "/deals/:dealId/calculators/bankSwap";
export const ROUTE_CALCULATORS_CASHFLOWS = "/calculators/cashflows";

export const ROUTE_CALCULATORS_PREPAYMENT = "/calculators/prepayment";
export const ROUTE_CALCULATORS_PREPAYMENT_MODAL = "/deals/:dealId/calculators/prepayment";
export const ROUTE_CALCULATORS_CAPPRICER_MODAL = "/deals/:dealId/calculators/capPricer";

export const ROUTE_CALCULATORS_CAP_PRICER = "/calculators/capPricer";

export const ROUTE_CALCULATORS_LOAN_PROCEEDS = "/calculators/loanProceeds";

export const ROUTE_ADMIN_CONTACT_EDIT = "/admin/contacts/:contactId/edit";
export const ROUTE_CONTACTS_CHANGE_PASS = "/admin/contacts/:contactId/reset-password";
export const ROUTE_ADMIN_CONTACTS = "/admin/contacts";
export const ROUTE_ADMIN_LIBOR = "/admin/libor";
export const ROUTE_ADMIN_COMPANIES = "/admin/companies";
export const ROUTE_ADMIN_COMPANY_SPONSORS = "/admin/companySponsors";
export const ROUTE_ADMIN_TEST_HARNESS = "/admin/testHarness";
export const ROUTE_ADMIN = "/admin";
export const ROUTE_ADMIN_COMPANY_CREDIT_RATINGS = "/admin/companyCreditRatings";
export const ROUTE_ADMIN_CAP_CALCULATOR_SETTINGS = "/admin/capCalculatorSettings";
export const ROUTE_ADMIN_SUP_CALCULATOR_SETTINGS = "/admin/supCalculatorSettings";
export const ROUTE_ADMIN_LOAN_PROCEED_SETTINGS = "/admin/loanProceedSettings";
export const ROUTE_ADMIN_CASH_OUT_PROCEEDS_LOAN_PROCEEDS_SETTINGS = "/admin/cashOutProceeds";
export const ROUTE_ADMIN_CASH_OUT_PROCEEDS_LOAN_PROCEEDS_RUN_TABLE = "/admin/loanProceedsRunTable";
export const ROUTE_ADMIN_GUEST_PERMISSIONS = "/admin/guestPermissions";
export const ROUTE_ADMIN_GUEST_GROUP = "/admin/guestGroup/:guestGroupId";
export const ROUTE_ADMIN_GUEST_INDIVIDUAL_SETTINGS = "/admin/guestSettings/:guestId";
export const ROUTE_ADMIN_GUEST_METRICS = "/admin/guestMetrics";
export const ROUTE_PIPELINE = "/pipeline/";
export const ROUTE_ADMIN_FINACIAL_REPORTING = "/admin/financialReporting";
export const ROUTE_ADMIN_API_TEST = "/admin/apiTest";
export const ROUTE_ADMIN_VENDOR_INTEGRATIONS = "/admin/vendorIntegrations";
export const ROUTE_ADMIN_HOLIDAY_CALENDAR = "/admin/holidayCalendarSettings";
export const ROUTE_ADMIN_CASHFLOW_TEST_HARNESS = "/admin/cashflowTestHarness";
export const ROUTE_ADMIN_APPS_SETTINGS = "/admin/appsSettings";
export const ROUTE_ADMIN_DOMO_REPORT = "/admin/domoReportSettings";

export const ROUTE_SOFT_QUOTE_QUOTE_EDIT = "/pipeline/softquote/deals/:dealId/quote/:quoteId";
export const ROUTE_PIPELINE_SOFT_QUOTES = "/pipeline/softquote";
export const ROUTE_PIPELINE_SOFT_QUOTE_DEAL = "/pipeline/softquote/deals/:dealId";
export const ROUTE_PIPELINE_SOFT_QUOTE_DEAL_EDIT = "/pipeline/softquote/deals/:dealId/edit";

export const ROUTE_PIPELINE_DEAD = "/pipeline/dead";

export const ROUTE_PIPELINE_ACTIVE = "/pipeline/active";
export const ROUTE_PIPELINE_ACTIVE_DEAL = "/pipeline/active/deals/:dealId";
export const ROUTE_PIPELINE_ACTIVE_DEAL_EDIT = "/pipeline/active/deals/:dealId/edit";

export const ROUTE_PIPELINE_ARCHIVED = "/pipeline/archived";
export const ROUTE_PIPELINE_ARCHIVED_DEAL = "/pipeline/archived/deals/:dealId";
export const ROUTE_PIPELINE_ARCHIVED_DEAL_EDIT = "/pipeline/archived/deals/:dealId/edit";
export const ROUTE_ARCHIVED_QUOTE_EDIT = "/pipeline/archived/deals/:dealId/quote/:quoteId";

export const ROUTE_ACTIVE_QUOTE_EDIT = "/pipeline/active/deals/:dealId/quote/:quoteId";

export const ROUTE_USERS_CHANGE_PASS = "/users/:userId/reset-password";

export const ROUTE_DEAL_LOAN_NEW = "/loan/:dealId";
export const ROUTE_DEAL_LOAN_VIEW = "/loan/:dealId/:loanId";
export const ROUTE_DEAL_QUOTE_VIEW = "/loan/:dealId/:loanId/OLD";
export const ROUTE_DEAL_LOAN_EDIT = "/loan/:isEditing/:dealId/:loanId";

export const ROUTE_LOAN_DETAILS_PAGE = "/portfolio/funds/:fundId/deals/:dealId/loans/:loanId/loanDetailsPage/:isNew";

export const PIPELINE_DEAL_QUOTE_COMPARISON = "/pipeline/deal/:dealId/quote-comparison";

export const REPORTS = "/reports";
export const NEW_REPORTS = "/reporting";

export const SELF_SERVICE_REPORTS_LIST = "/reporting/self-service-reports";
export const SELF_SERVICE_CREATE_REPORT = "/reporting/self-service-reports/create";
export const SELF_SERVICE_EDIT_REPORT = "/reporting/self-service-reports/edit/:selfServiceReportId";
export const SELF_SERVICE_VIEW_REPORT = "/reporting/self-service-reports/view/:selfServiceReportId";

export const PIPELINE = "/pipeline";
export const PIPELINE_DEAD = "/pipeline/dead";

export const REPORTS_LENDER_EXPOSURE = "/reports/lenderExposure";
export const REPORTS_RECOURSE_EXPOSURE = "/reports/recourseExposure";
export const REPORTS_PREPAYMENT = "/reports/prepayment";
export const REPORTS_HEDGE = "/reports/hedgeReport";

export const HEDGE_DETAILS = "/hedge/:fundId?/:dealId?/:hedgeId?";
export const HEDGE_ESCROWS_LEDGER = "/hedge/:fundId?/:dealId?/:hedgeId?/escrowLedger/:replacingHedgeId?";

export const CASHFLOWS_PAGE = "/portfolio/funds/:fundId?/deals/:dealId?/cashflowsPage";
export const NOTIFICATIONS_PAGE = "/notifications";

export const ROUTE_PROFILE_PASSWORD_RESET = "/profile/passwordReset";

export const ROUTE_GUEST_LANDING = "/guestlanding";
export const ROUTE_GUEST_COMPANY_LANDING_BASE = "/guestcompanylanding";
export const ROUTE_GUEST_COMPANY_LANDING = "/guestcompanylanding/:companyId";

// NEW PAGES
export const ROUTE_DASHBOARD = "/DealsDashboard";
export const ROUTE_BROKER_DASHBOARD = "/broker-deals";

export const ROUTE_APPS = "/apps";
export const ROUTE_DEAL = "/deal/:dealId";
export const ROUTE_DEAL_ANALYSIS = "/deal/:dealId/analysis";

export const ROUTE_DEAL_LITE = "/deal-lite/:dealId";

export const ROUTE_PROPERTY_DETAIL_EDIT = "/properties/:propertyId/edit/:sectionName/:dealId?";
export const ROUTE_PROPERTY_DETAIL = "/properties/:propertyId/:dealId?";

export const ROUTE_HEDGE_DETAIL = "/hedges/:hedgeId/:dealId?";
export const ROUTE_HEDGE_DETAIL_EDIT = "/hedges/:hedgeId/edit/:sectionName";

export const ROUTE_LOAN_DETAIL = "/loans/:loanId";
export const ROUTE_LOAN_DETAIL_EDIT = "/loans/:loanId/edit/:sectionName/:id?/:index?";

export const ROUTE_QUOTE_DETAIL = "/quotes/:dealId/:quoteId";
export const ROUTE_QUOTES_BY_DEAL = "/quotes/:dealId";

export const ROUTE_QUOTE_HISTORY = "/quoteHistory/:loanId";

export const ROUTE_DEAL_DETAIL_EDIT = "/deal/:dealId/edit/:sectionName";

export const ROUTE_DEAL_SETTINGS = "/dealSettings/:dealId";
export const ROUTE_LENDER_REPORTS = "/deal/:dealId/lender-reports";
export const ROUTE_LENDER_REPORT_DETAILS = "/deal/:dealId/lender-reports/:reportId";
export const ROUTE_LENDER_REPORTS_SETUP = "/deal/:dealId/lender-reports-setup/:reportId";
export const ROUTE_LENDER_REPORTS_NOI_SETUP = "/deal/:dealId/lender-reports-noi-config/:reportId";
export const ROUTE_LENDER_REPORTS_DSCR_SETUP = "/deal/:dealId/lender-reports-dscr-config/:reportId";
export const ROUTE_LENDER_REPORTS_DEBT_YIELD_SETUP = "/deal/:dealId/lender-reports-debt-yield-config/:reportId";
export const ROUTE_LENDER_REPORTS_PREVIEW = "/deal/:dealId/lender-reports-preview/:type/:reportId/:rgiId/:dealName";
export const ROUTE_DEAL_FILE_DETAILS = "/deal/:dealId/lender-reports/files/:fileId";

export const ROUTE_LENDER_REPORTS_COMPONENTS_NOI_CALC = "/deal/:dealId/lender-reports/:reportId/noi-calculation/:reportComponentId";
export const ROUTE_LENDER_REPORTS_COMPONENTS_DSCR_CALC = "/deal/:dealId/lender-reports/:reportId/dscr-calculation/:reportComponentId";
export const ROUTE_LENDER_REPORTS_COMPONENTS_DY_CALC = "/deal/:dealId/lender-reports/:reportId/debt-yield-calculation/:reportComponentId";

export const ROUTE_LENDER_REPORTS_PROJECTED_NOI_SETUP = "/deal/:dealId/lender-reports-projected-noi-config/:reportId";
export const ROUTE_LENDER_REPORTS_PROJECTED_DSCR_SETUP = "/deal/:dealId/lender-reports-projected-dscr-config/:reportId";
export const ROUTE_LENDER_REPORTS_PROJECTED_DEBT_YIELD_SETUP = "/deal/:dealId/lender-reports-projected-debt-yield-config/:reportId";

export const ROUTE_LENDER_REPORTS_COMPONENTS_PROJECTED_NOI_CALC = "/deal/:dealId/lender-reports/:reportId/projected-noi-calculation/:reportComponentId";
export const ROUTE_LENDER_REPORTS_COMPONENTS_PROJECTED_DSCR_CALC = "/deal/:dealId/lender-reports/:reportId/projected-dscr-calculation/:reportComponentId";
export const ROUTE_LENDER_REPORTS_COMPONENTS_PROJECTED_DY_CALC = "/deal/:dealId/lender-reports/:reportId/projected-debt-yield-calculation/:reportComponentId";

export const SREO_SCREENER = "/sreoScreener";
export const POLICIES_AND_AGREEMENTS = "/termsAndConditions";

export const ROUTE_DEAL_SCREENER = "/dealScreener";
export const ROUTE_DEAL_SCREENER_EDC = (campaignId = ":campaignId") => `/dealScreener/${campaignId}`;

export const ROUTE_CAMPAIGNS = "/campaigns";
export const ROUTE_INDIVIDUAL_CAMPAIGN = "/campaigns/:campaignId";
export const ROUTE_EMAIL_DRAFT = "/campaigns/:campaignId/email-draft";
export const ROUTE_EDC_MASTER_CONTACT_LIST = "/campaigns/contacts";

export const DEBT_VALUATION_SETUP = "/debtValuation/globalSettings";
export const DEBT_VALUATION_DASHBOARD = "/debtvaluation";
export const DEBT_VALUATION_SPREADS = "/debtvaluationSpreads";

export const LENDER_REPORTING_DASHBOARD = "/lenderReportingDashboard";
export const LENDER_REPORTING_SETTINGS = "/lenderReportingDashboard/settings";
export const LENDER_REPORTING_LENDER_VIEW = "/lenderReportingDashboard/lender/:reportId";
export const LENDER_REPORTING_TASK_VIEW = "/lenderReportingDashboard/tasks/:reportId";
export const LENDER_REPORTING_SUBMITTED = "/lenderReportingDashboard/submitted/:reportId";

export const REFI_BREAKEVEN_VIEW = "/refi-breakeven/:linkId";
export const PREPAYMENT_SNAPSHOT_VIEW = "/prepayment/snapshot/:dealId";
export const VALUATION_SENSITIVITY_SNAPSHOT_VIEW = "/valuation-sensitivity/snapshot/:dealId";
export const REFI_CASHOUT_VIEW = "/refi-cashout/:linkId";

export const ROUTE_ONBOARDING_VIEW = "/onboarding";
